import { Tokens } from '@/assets/tokens'
import { Flex } from '@/components'
import { Check, X } from 'lucide-react'

export const PASSWORD_RULES = [
  { id: 'length', label: 'Mínimo de 8 caracteres', test: (p: string) => p.length >= 8 },
  { id: 'upper', label: 'Pelo menos uma letra maiúscula', test: (p: string) => /[A-Z]/.test(p) },
  { id: 'lower', label: 'Pelo menos uma letra minúscula', test: (p: string) => /[a-z]/.test(p) },
  { id: 'number', label: 'Pelo menos um número', test: (p: string) => /[0-9]/.test(p) },
  {
    id: 'special',
    label: 'Pelo menos um caractere especial',
    test: (p: string) => /[\^$*.[\]{}()?\-"!@#%&/\\,><':;|_~+=]/.test(p),
  },
]

function ValidationRow({ label, isMatch }: { label: string; isMatch: boolean }) {
  const color = isMatch ? Tokens.ColorUIPrimary : Tokens.ColorTextSecondary

  return (
    <Flex $type="row" $align="center" $gap={8}>
      {isMatch ?
        <Check size={14} color={Tokens.ColorUIPrimary} strokeWidth={3} />
      : <X size={14} color={color} strokeWidth={3} />}
      <span style={{ fontSize: '12px', color, transition: 'all 0.2s' }}>{label}</span>
    </Flex>
  )
}

export function PasswordComplexity({ value }: { value: string }) {
  if (!value) return null

  return (
    <Flex $type="column" $gap={4} style={{ marginTop: '-12px', marginBottom: '12px' }}>
      {PASSWORD_RULES.map((rule) => (
        <ValidationRow key={rule.id} label={rule.label} isMatch={rule.test(value)} />
      ))}
    </Flex>
  )
}

export function PasswordMatch({ value, target }: { value: string; target: string }) {
  if (!value) return null

  const isMatch = value === target && value.length > 0

  return (
    <Flex $type="column" $gap={4} style={{ marginTop: '-12px', marginBottom: '12px' }}>
      <ValidationRow label={isMatch ? 'As senhas coincidem' : 'As senhas não coincidem'} isMatch={isMatch} />
    </Flex>
  )
}
